import React from 'react'
import PropTypes from 'prop-types'
import { Image, Slider } from '@sainsburys-tech/bolt'
import { agnostify } from '@sainsburys-tech/boltui-utils'
import { onLinkClickFn } from '../../../helpers/ComponentHelper'
import * as Styled from './M011.styles'

/**
 * - M011 is a grid of logos of promo brands.
 * - It can display up to 9 brands
 * - On mobile, it displays a bolt slider with maximum two promo brands on each slide
 */
const M011 = ({ brands, linkTarget, onLinkClick }) => {
  const brandCard = (brand, index, gridSize = 4) => {
    const { linkUrl, linkTitle, altText, mainImage } = brand
    const validLinkUrl = agnostify(linkUrl)

    return (
      <Styled.Container
        xs={gridSize}
        gutterSize='16px'
        numberOfColumns={12}
        data-test={`m011-card-${index}`}
        key={`brand-card-${index}`}
        forwardedAs='a'
        href={validLinkUrl}
        onClick={(e) => onLinkClickFn(e, onLinkClick, linkUrl)}
        target={linkTarget}
        title={linkTitle}
      >
        <Image data-test={`m011-card-${index}-image`} alt={altText} src={mainImage} width='auto' height='100%' />
      </Styled.Container>
    )
  }

  const renderSlider = () => {
    const brandsGroup = []
    const groupingArray = [1, 3, 5, 7, 9]
    const slideProps = {
      itemsPerSlideXs: 2,
      itemsPerSlideSm: 2,
      itemsPerSlideMd: 2,
      isInfiniteCycle: true,
      items: []
    }
    groupingArray.forEach((group) => {
      if (brands.length >= group) {
        const brandGroupingIndex = brands.map((brand, index) => brandCard(brand, index, 6))
        brandsGroup.push(brandGroupingIndex)
      }
    })
    // eslint-disable-next-line prefer-destructuring
    slideProps.items = brandsGroup[0]
    return <Slider {...slideProps} />
  }

  return (
    <Styled.Wrapper className='m011' data-test='m011-wrapper' gutterValue={0}>
      <Styled.CardContainer data-test='m011-slider' row='xs' hidden='md' xs={12} gutterValue={0} isSlider>
        {renderSlider()}
      </Styled.CardContainer>
      <Styled.CardContainer
        data-test='m011-card-container'
        hidden='xs'
        row='md'
        xs={12}
        gutterValue={1}
        gutterSize='16px'
      >
        {brands.map((brand, index) => brandCard(brand, index))}
      </Styled.CardContainer>
    </Styled.Wrapper>
  )
}

M011.propTypes = {
  /** Required array of brands */
  brands: PropTypes.arrayOf(
    PropTypes.shape({
      /** Brand name */
      name: PropTypes.string,
      /** Optional link title, can be seen when hovering over each brand container */
      linkTitle: PropTypes.string,
      /** Image */
      mainImage: PropTypes.string,
      /** Written copy that describes the Image */
      altText: PropTypes.string,
      /** Optional link url */
      linkUrl: PropTypes.string
    })
  ).isRequired,
  /** Option of opening in a new tab, defaults to an empty string  */
  linkTarget: PropTypes.oneOf(['', '_blank', '_self']),
  /** Optional function to handle click on each brand container */
  onLinkClick: PropTypes.func
}

M011.defaultProps = {
  linkTarget: '',
  onLinkClick: null
}

export default M011
